function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "logo-oxy-educacional",
  d: "M189.233,234.048a6.7,6.7,0,1,1,0-13.393h62.211V153.8H183.761A14.781,14.781,0,0,0,169,168.561v63.867a14.8,14.8,0,0,0,14.761,14.761h67.683v-13.1H189.233ZM203.526,166.9h26.893a6.7,6.7,0,1,1,0,13.393H203.526a6.7,6.7,0,1,1,0-13.393Zm-6.7,33.59a6.714,6.714,0,0,1,6.732-6.7h26.893a6.707,6.707,0,0,1,6.7,6.7h0a6.707,6.707,0,0,1-6.7,6.7H203.562a6.692,6.692,0,0,1-6.732-6.7Z",
  transform: "translate(-169 -153.8)"
});

const SvgLogoOxyEducacional = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 82.444,
    height: 93.388,
    viewBox: "0 0 82.444 93.388",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogoOxyEducacional, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-oxy-educacional.73c8781c.svg";
export { ForwardRef as ReactComponent };